"use strict";export function findNodeHandle(componentOrHandle){return componentOrHandle}